import OrderHeader from "./order/OrderHeader";

export default function Home() {
    return <div className="flex flex-col h-screen min-h-0">
        <OrderHeader title={"Accueil"} />
        <iframe src="https://universus-tech.notion.site/ebd/1ae2d82c5608800a991df3763075872b" className="flex flex-grow flex-col items-center justify-center h-screen" frameborder="0" allowfullscreen />
    </div>
}